<div class="cardLayout">
    <div class="d-flex flex-row align-items-center justify-content-between">
        <h4>Who's Calling</h4>
        <div class="ivr-title-row d-flex flex-row align-items-center psic-gap-4">
            <mat-icon [svgIcon]="'phone'" class="dg_mg-60-color"></mat-icon>
            <h6 class="ivr-phone">{{ phoneNumber }}</h6>
        </div>
    </div>

    @if(profileMismatch()){
    <lib-alert
        style="width: fit-content"
        [alertText]="
            'The caller’s phone number doesn’t match the selected role. Verify the caller’s role and update it if necessary'
        "
        [alertTheme]="'error'"
        [alertType]="'small'"
    ></lib-alert>
    }

    <lib-input-radio
        [radioLeft]="radioLeft"
        [field]="callerTypeField"
        [ngModel]="selectedCaller()"
        (ngModelChange)="onSelect($event)"
        [class.ivr-radio-group--error]="profileMismatch()"
    ></lib-input-radio>

    @if (producerDetails()) {
    <div class="separator"></div>
    <div class="ivr-producer-details d-flex flex-row justify-content-between">
        <div class="ivr-producer d-flex flex-column">
            <div class="caption-bold">Producer Code</div>
            <div class="caption ivr-producer-value d-flex align-items-center psic-gap-1">
                <input
                    class="ivr-producer-code-input caption"
                    [value]="selectedProducerCode()"
                    (input)="selectedProducerCode.set($any($event.target).value)"
                />
                <mat-icon
                    class="mat-icon-20 p1-50-color"
                    [svgIcon]="'new-window-open'"
                    (click)="navigateToProducer(selectedProducerCode())"
                ></mat-icon>
            </div>
        </div>

        @for (item of producerDetails()!.slice(1); track item.label) {
        <div class="vertical-separator"></div>
        <div class="ivr-producer d-flex flex-column psic-gap-1">
            <div class="disclaimer-bold">{{ item.label }}</div>
            <div class="caption">{{ item.value }}</div>
        </div>
        }
    </div>
    }
</div>
